import { scaleOrdinal } from '@visx/scale';
import { AccessorFunction, DatumId } from '../core/Chart.types';

export const createDefaultColorScale = <Datum>(data: Datum[], getIdentifier: AccessorFunction<Datum, DatumId>, palette: string[]) =>
  scaleOrdinal<DatumId, string>({
    domain: data.map(d => getIdentifier(d)),
    range: palette,
  });
